<!--  -->
<template>
  <div class='index'>
    <page-top/>
    <IndexHeader :userInfo="userInfo"></IndexHeader>
    <IndexBody :canAdd="status === 2"></IndexBody>
  </div>
</template>

<script>
import IndexHeader from '@/components/header.vue'
import IndexBody from './components/body.vue'
import PageTop from '@/components/pageTop.vue'
export default {
  components: {
    IndexHeader,
    IndexBody,
    PageTop
  },
  data() {
    return {
      userInfo: {
        businessPic:  '',
        managePic:  '',
        productionPic:  '',
        productPic:  '',
      },
      status: 0,
    }
  },
  computed: {},
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  this.getData()
  },
  methods: {
  
    getData() {
      this.$http.get('/api/WebUser/QueryUserDetail').then(res => {
        this.userInfo = res.data
        this.status = res.data.status
      })
    }
  },
}
</script>
<style lang='scss' scoped>

</style>